import React from "react";
import { formatCurrency } from "../../lib/costEngine";
import { Card, CardContent } from "../ui/card";
import { Input } from "../ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import { Trash2 } from "lucide-react";

export function CostRow({ item, onUpdate, onRemove }) {
  const isTravel = item.amount == null;
  const isFixed = item.section === "fixed";
  return (
    <TableRow data-testid={`cost-row-${item.id}`}>
      <TableCell>
        <Input
          data-testid={`item-name-${item.id}`}
          value={item.name}
          onChange={(e) => onUpdate(item.id, "name", e.target.value)}
          className="h-9 border-transparent hover:border-input focus:border-input bg-transparent px-2"
        />
        {isTravel && item.note && (
          <p className="text-xs text-muted-foreground px-2 mt-0.5">{item.note}</p>
        )}
      </TableCell>
      <TableCell>
        {isTravel || isFixed ? (
          <div
            data-testid={`item-qty-${item.id}`}
            className={`text-right text-sm pr-2 ${isFixed ? "tabular-nums text-foreground" : "text-muted-foreground"}`}
          >
            {item.qty == null ? "—" : Number(item.qty).toLocaleString()}
          </div>
        ) : (
          <Input
            data-testid={`item-qty-${item.id}`}
            type="number"
            value={item.qty}
            onChange={(e) => onUpdate(item.id, "qty", e.target.value)}
            className="h-9 text-right tabular-nums px-2 w-24 ml-auto"
          />
        )}
      </TableCell>
      <TableCell>
        {isTravel ? (
          <div className="text-right text-muted-foreground text-sm pr-2">—</div>
        ) : (
          <Input
            data-testid={`item-unit-${item.id}`}
            type="number"
            step="0.01"
            value={item.unit}
            onChange={(e) => onUpdate(item.id, "unit", e.target.value)}
            className="h-9 text-right tabular-nums px-2 w-28 ml-auto"
          />
        )}
      </TableCell>
      <TableCell className="text-right tabular-nums font-medium" data-testid={`item-amount-${item.id}`}>
        {isTravel ? <span className="text-xs text-amber-600 font-medium">Actual + 15%</span> : formatCurrency(item.amount)}
      </TableCell>
      <TableCell>
        {!isTravel && (
          <button
            data-testid={`remove-item-${item.id}`}
            onClick={() => onRemove(item.id)}
            className="text-muted-foreground hover:text-destructive transition-colors"
            aria-label="Remove line item"
          >
            <Trash2 className="h-4 w-4" />
          </button>
        )}
      </TableCell>
    </TableRow>
  );
}

export function SectionTable({ title, rows, subtotal, subtotalTestId, preamble, onUpdate, onRemove }) {
  return (
    <Card>
      <CardContent className="p-0">
        <div className="px-4 py-2.5 border-b border-border bg-accent/40">
          <p className="font-display font-600 text-sm text-foreground">{title}</p>
        </div>
        {preamble}
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[42%]">Line Item</TableHead>
              <TableHead className="text-right">Qty</TableHead>
              <TableHead className="text-right">Unit ($)</TableHead>
              <TableHead className="text-right">Amount</TableHead>
              <TableHead className="w-8"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((item) => (
              <CostRow key={item.id} item={item} onUpdate={onUpdate} onRemove={onRemove} />
            ))}
            <TableRow className="bg-muted/40">
              <TableCell colSpan={3} className="text-right font-medium">
                {title} Subtotal
              </TableCell>
              <TableCell data-testid={subtotalTestId} className="text-right tabular-nums font-semibold">
                {formatCurrency(subtotal)}
              </TableCell>
              <TableCell />
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
